import React from "react";

import useStyles from "./style";
import { useHistory } from 'react-router-dom';

import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Badge from "@material-ui/core/Badge";
import Typography from "@material-ui/core/Typography";


function WithSearchCart({ onClick, title, totalCart }) {

  const classes = useStyles();
  const history = useHistory()
  
  return (
    <div className={classes.header}>
      <div className={classes.wrapHeader}>
        <div>
          <IconButton size="small" onClick={() => history.goBack()}>
            <ArrowBackIcon className={classes.icCart} />
          </IconButton>
        </div>
        <div className={classes.wrapTitle}>
          <Typography noWrap className={classes.title}>{title}</Typography>
        </div>
        <div>
        <IconButton size="small" onClick={() => history.push("/browse")}>
            <SearchIcon className={classes.icCart} />
          </IconButton>
          <IconButton size="small" onClick={() => history.push('/cart')}>
            <Badge badgeContent={totalCart} color="secondary">
              <ShoppingCartIcon className={classes.icCart} />
            </Badge>
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default WithSearchCart;
